export default function checkExists(value) {
  if (value) {
    return true;
  }

  return "Required Field";
}
